module.exports = __webpack_public_path__ + "img/bg-img-four.322fe15c.png";